import {DEFAULT_STATE} from '../../reducers/fortnite-game/activeUsers.reducer';
import {ActiveUsersOverviewState} from '../../reducers/fortnite-game/activeUsersOverview.reducer';

export const getActiveUsersState = (state): typeof DEFAULT_STATE => {
    return state.get('activeUsers').toJS();
};

export const getActiveUsersOverviewState = (state): ActiveUsersOverviewState => {
    return state.get('activeUsersOverview').toJS();
};
